export const MAX_CHARACTER_COUNT = 2000;
export const WARNING_THRESHOLD = MAX_CHARACTER_COUNT * 0.9;
export const MAX_MENTIONS = 20;
export const MAX_HASHTAGS = 30;
